export function TraceDeepCTAPanel({ onRegisterInterest, onBack }: { onRegisterInterest: () => void; onBack: () => void }) {
  return (
    <div className="traceDeepCTAPanel">
      <header className="traceDeepHeader">
        <span className="traceDeepTier">Trace</span>
        <h4>Trace interest list</h4>
      </header>
      <p>Trace is not live and checkout is not available. Registering interest does not purchase a service, start an evaluation or reserve a team review.</p>
      <p>This local report includes no additional provider assessment, verified risk findings or live genre benchmark.</p>
      <div className="traceDeepActions">
        <button type="button" className="traceDeepRegister" onClick={onRegisterInterest}>Register for Trace</button>
        <button type="button" className="traceDeepBack secondaryButton" onClick={onBack}>Back</button>
      </div>
    </div>
  );
}
